import * as React from "react";
import { cn } from "../../lib/utils";

const variants = {
  default:
    "bg-[hsl(var(--bg-elev-2))] text-[hsl(var(--fg))] border-[hsl(var(--border))]",
  success:
    "bg-[hsl(var(--success)/0.12)] text-[hsl(var(--success))] border-[hsl(var(--success)/0.35)]",
  warning:
    "bg-[hsl(var(--warning)/0.12)] text-[hsl(var(--warning))] border-[hsl(var(--warning)/0.4)]",
  danger:
    "bg-[hsl(var(--danger)/0.12)] text-[hsl(var(--danger))] border-[hsl(var(--danger)/0.4)]",
  muted:
    "bg-[hsl(var(--bg-elev-2))] text-[hsl(var(--muted))] border-[hsl(var(--border))]",
  primary:
    "bg-[hsl(var(--primary)/0.12)] text-[hsl(var(--primary))] border-[hsl(var(--primary)/0.35)]",
};

export function Badge({ variant = "default", className, children, ...props }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md border text-[11px] font-medium uppercase tracking-wider",
        variants[variant] || variants.default,
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}
